import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef} from '@angular/core';
import { ScreenManagerService } from '../../../../core/services/screen-manager.service';

@Component({
	selector: 'ng-mf-app-kamona-alert-banner',
	templateUrl: './kamona-alert-banner.component.html',
	styleUrls: ['./kamona-alert-banner.component.scss']
})
export class KamonaAlertBannerComponent implements OnInit, OnChanges {
	@Input() title: string;
	@Input() message: string;
	@Input() messageTemplate: TemplateRef<any>;
	@Input() breakpoint: number;
	@Input() buttonText: string
  @Input() buttonLoading: boolean;
	@Input() bannerType: BannerType;
	@Input() buttonPrefixIcon: TemplateRef<any>;
	@Input() buttonSuffixIcon: TemplateRef<any>;
  @Input() changeIconOnMobile = true;
  @Input() contentClass = '';
  @Input() actionTemplate: TemplateRef<any>;
  @Input() buttonPositioning: 'wrap-flex-end' | 'wrap-flex-start' | 'no-wrap-flex-end' = 'no-wrap-flex-end';
  @Input() useSameIconForDesTopAndMobile = false;
  @Input() verticalMargin = true;
	@Input() iconPath?: string;

	@Output() emitSubmit = new EventEmitter();
  @Input() wrapAction = false;

  get buttonPositioningClass() {
    switch (this.buttonPositioning) {
      case 'no-wrap-flex-end':
        return 'flex-nowrap justify-between'
      case 'wrap-flex-end':
        return 'flex-wrap justify-between'
      case 'wrap-flex-start':
        return 'flex-wrap'
      default:
        break;
    }
  }

	isMobile: boolean;
  messageType:string

  readonly messageTypes = {
    template: 'template',
    text: 'text'
  }

	constructor(private screenManagerService: ScreenManagerService) {
	}

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.message || changes.messageTemplate) {
      this.setMessageType()
    }
  }

	ngOnInit(): void {
		this.initialize();
    this.setMessageType()
	}

	initialize() {
    this.isMobile = this.screenManagerService.isMobile()
    this.screenManagerService.isMobile$.subscribe((isMobile) => {
      this.isMobile = isMobile;
    })
	}

  setMessageType() {
      this.messageType = this.messageTypes.text

      if(this.messageTemplate) {
        this.messageType = this.messageTypes.template
      }
  }

	submit() {
		this.emitSubmit.emit();
	}

}

export type BannerType = 'info' | 'error' | 'warning' | 'banner-pos-uninsured'
